// extracted by mini-css-extract-plugin
export var searchHeader = "_6m-0";
export var searchHeaderDark = "_6m-1";